import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import en from './locales/en/translation.json'
import es from './locales/es/translation.json'
import it from './locales/it/translation.json'
import fr from './locales/fr/translation.json'
import pt from './locales/pt/translation.json'
import pl from './locales/pl/translation.json'
import { notifyError } from '@/infrastructure/sentry'

const resources = {
  es: {
    translation: es
  },
  en: {
    translation: en
  },
  it: {
    translation: it
  },
  fr: {
    translation: fr
  },
  pt: {
    translation: pt
  },
  pl: {
    translation: pl
  }
}

function FindInitialLanguage() {
  const userPreferredLang = localStorage.getItem('userPreferredLang')
  if (
    !['en', 'es', 'it', 'pt', 'fr', 'pl'].some((l) => l === userPreferredLang)
  ) {
    localStorage.setItem('userPreferredLang', 'en')
    return 'en'
  }
  if (userPreferredLang) {
    return userPreferredLang
  }

  return 'en'
}

i18next
  .use(initReactI18next)
  .use(Backend)
  .init({
    lng: FindInitialLanguage(),
    resources,
    saveMissing: true,
    missingKeyHandler: function (_, __, key) {
      notifyError(
        new Error(`Copy not found for key: ${key} - Please review (:`)
      )
    }
  })
